import { useTranslation } from '@nucleus-commerce/i18n/react';
import { Button } from '@nucleus-commerce/ui/components/button';

import { useTourOptional } from '../tour-context';
import { useRouteTours } from '../use-route-tours';

/** The empty-state link: "Take a 1-minute tour of this page", for the route's first tour. */
export function RouteTourLink() {
  const tour = useTourOptional();
  return tour?.enabled ? <EmptyStateTourButton /> : null;
}

function EmptyStateTourButton() {
  const tour = useTourOptional();
  const tours = useRouteTours();
  const { t } = useTranslation('common');
  const first = tours[0];
  if (!tour || !first) return null;
  return (
    <Button
      type="button"
      variant="link"
      size="sm"
      className="h-auto p-0 text-xs"
      onClick={() => void tour.start(first.id, { source: 'empty-state' })}
    >
      {t('tour.emptyLink')}
    </Button>
  );
}
